var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-top":"40px"}},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-4"},[_c('tithiform')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }